module.exports = __webpack_public_path__ + "img/premium_gold_smf.78d6d7d3.png";